/**
 * Created by claudio iozzia on 15/06/2017.
 */
import {ActionLocal} from './actions.service';
import {Ic, IDesignSolution} from '../../models/common';
import {type} from '../../common/utils';


export class ApplicationTestActions {

  static ActionType = {
    TEST_CATALOG: type('[ApplicationTestActions] TEST_CATALOG'),
    TEST_COMPLETED: type('[ApplicationTestActions] TEST_COMPLETED'),
  };

  public static testCatalog(): ActionLocal {
    return {type: ApplicationTestActions.ActionType.TEST_CATALOG};
  }

  public static testCompleted(): ActionLocal {
    return {type: ApplicationTestActions.ActionType.TEST_COMPLETED};
  }

}
